/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { logError } from '@ctsu/loader';
import { text } from 'components/common/Text';


export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    logError(error, errorInfo, this.state);
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return (
        <div className="app-container rostering">

          <div className="app-body-center row p-4 bg-white shadow-sm align-items-center">
            <div className="app-body-content">
              <div className="app-body-error-wrapper">
                <div className="app-body-error-message-title">{text('error_boundary.something_went_wrong')}</div>
                <p>{text('error_boundary.contact_help_desk')}</p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return children;
  }
}
